import React, { useState } from "react";
import {
  categories,
  departments,
  divisions,
  locations,
  priorities,
  reasons,
  status,
  types,
} from "../constant";
import { userRequest } from "../request";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

export const AddProject = () => {
  const user = useSelector((state) => state.user);
  const token = useSelector((state)=> state.user.user.token)
  const [formData, setFormData] = useState({
    projectName: "",
    reason: reasons[0],
    type: types[0],
    division: divisions[0],
    category: categories[0],
    priority: priorities[0],
    department: departments[0],
    startDate: "",
    endDate: "",
    location: locations[0],
    status: status[0],
    user: user._id,
  });

  const [themeError, setThemeError] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validDate = (startDateStr, endDateStr) => {
    // Split the date strings and convert parts to numbers
    const [startYear, startMonth, startDay] = startDateStr.split("-").map(Number);
    const [endYear, endMonth, endDay] = endDateStr.split("-").map(Number);
  
    // Create Date objects
    const startDate = new Date(startYear, startMonth - 1, startDay);
    const endDate = new Date(endYear, endMonth - 1, endDay);
  
    // Compare the dates
    return startDate <= endDate;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validDate(formData.startDate, formData.endDate)) {
      toast.error("Start Date should be less than End Date");
      return;
    }
    if (formData.projectName === "") {
      setThemeError(true);
      return;
    }
    setThemeError(false);

    try {
      e.preventDefault();
      const response = await userRequest(token).post("/project", {
        projectName: formData.projectName,
        startDate: formData.startDate,
        endDate: formData.endDate,
        reason: formData.reason,
        type: formData.type,
        division: formData.division,
        category: formData.category,
        priority: formData.priority,
        department: formData.department,
        status: formData.status,
        location: formData.location,
        user: user.user._id,
      });
      console.log(response);

      if (response.status === 201) {
        toast.success("project has been created!");
        setThemeError(false);
        setFormData({
          projectName: "",
          reason: reasons[0],
          type: types[0],
          division: divisions[0],
          category: categories[0],
          priority: priorities[0],
          department: departments[0],
          startDate: "",
          endDate: "",
          location: locations[0],
          status: status[0],
          user: user._id,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="relative flex justify-center pb-20 lg:grid lg:grid-cols-12 lg:p-10 p-3 mb-20 shadow-2xl bg-white rounded-2xl"
    >
      <div className=" lg:col-span-10">
        <div className="lg:grid grid-cols-3 flex  flex-col lg:gap-6 gap-4">
          <div className=" col-span-2">
            <textarea
              name="projectName"
              className={` resize-none border-2 ${
                themeError ? "border-red-500" : ""
              } w-full p-2 rounded-lg border-gray-400`}
              rows={3}
              placeholder="Enter project theme"
              id="projectName"
              value={formData.projectName}
              onChange={handleChange}
            ></textarea>
            {themeError && (
              <p className=" text-red-500">Project Theme required</p>
            )}
          </div>
          <div className="col-span-1">
            <button
              type="submit"
              className=" hidden lg:block bg-primary px-6 text-white rounded-3xl p-2 absolute right-4  w-auto m-2"
            >
              Save Project
            </button>
          </div>

          <div className="col-span-1">
            <label htmlFor="reason" className=" text-gray-400">
              Reason
            </label>
            <select
              name="reason"
              id="reason"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.reason}
              onChange={handleChange}
            >
              {reasons.map((reason, index) => (
                <option key={index} value={reason} name="reason" id="reason">
                  For {reason}
                </option>
              ))}
            </select>
          </div>
          <div className=" col-span-1">
            <label htmlFor="type" className=" text-gray-400">
              Type
            </label>

            <select
              name="type"
              id="type"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.type}
              onChange={handleChange}
            >
              {types.map((type, index) => (
                <option key={index} name="type" value={type} id="type">
                  {type}
                </option>
              ))}
            </select>
          </div>
          <div className="col-span-1">
            <label htmlFor="division" className=" text-gray-400">
              Division
            </label>

            <select
              name="division"
              id="division"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.division}
              onChange={handleChange}
            >
              {divisions.map((division, index) => (
                <option key={index} name="type" value={division} id="division">
                  {division}
                </option>
              ))}
            </select>
          </div>

          <div className=" col-span-1">
            <label htmlFor="category" className=" text-gray-400">
              Category
            </label>

            <select
              name="category"
              id="category"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.reason}
              onChange={handleChange}
            >
              {categories.map((cat, index) => (
                <option key={index} name="cat" value={cat}>
                  Quality {cat}
                </option>
              ))}
            </select>
          </div>
          <div className=" col-span-1">
            <label htmlFor="priority" className=" text-gray-400">
              Priority
            </label>

            <select
              name="priority"
              id="priority"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.reason}
              onChange={handleChange}
            >
              {priorities.map((priority, index) => (
                <option
                  key={index}
                  name="priority"
                  value={priority}
                  id="priority"
                >
                  {priority}
                </option>
              ))}
            </select>
          </div>
          <div className=" col-span-1">
            <label htmlFor="department" className=" text-gray-400">
              Department
            </label>

            <select
              name="department"
              id="department"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.reason}
              onChange={handleChange}
            >
              {departments.map((department, index) => (
                <option
                  key={index}
                  name="department"
                  value={department}
                  id="department"
                >
                  {department}
                </option>
              ))}
            </select>
          </div>
          <div className=" col-span-1">
            <label htmlFor="startdate" className=" text-gray-400">
              Start Date as per project plan
            </label>

            <input
              type="date"
              name="startDate"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.startDate}
              onChange={handleChange}
            />
          </div>
          <div className=" col-span-1">
            <label htmlFor="enddate" className=" text-gray-400">
              End Date as per project plan
            </label>

            <input
              type="date"
              name="endDate"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.endDate}
              onChange={handleChange}
            />
          </div>
          <div className=" col-span-1">
            <label htmlFor="location" className=" text-gray-400">
              Location
            </label>

            <select
              name="location"
              id="location"
              className=" w-full border-2 p-2 rounded-lg border-gray-400"
              value={formData.location}
              onChange={handleChange}
            >
              {locations.map((location, index) => (
                <option
                  key={index}
                  name="location"
                  value={location}
                  id="location"
                >
                  {location}
                </option>
              ))}
            </select>
          </div>
          <div className=" col-span-1"></div>
          <div className=" col-span-1"></div>
          <div className=" col-span-1">
            <label htmlFor="status" className=" text-gray-400">
              Status:
            </label>

            <select
              name="status"
              id="status"
              value={formData.status}
              onChange={handleChange}
            >
              {status.map((status, index) => (
                <option
                  key={index}
                  name="status"
                  value={status}
                  className=" outline-none"
                  id="location"
                >
                  {status}
                </option>
              ))}
            </select>
          </div>
          <div className=" col-span-1  lg:hidden">
            <button
              type="submit"
              className=" bg-primary w-full text-white rounded-3xl p-2"
            >
              Save Project
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};
